module.exports = __webpack_public_path__ + "7ab1c7a625a7396fe90881bfd2887fef.jpg";